import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { RoleResponse } from '@/api/roles/types';

export const createModalConfig = (orgs: any, allRoles: RoleResponse[]) =>
  [
    {
      label: 'Фамилия',
      key: 'lastName',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Имя',
      key: 'firstName',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Отчество',
      key: 'middleName',
      type: 'text',
    },
    {
      label: 'Организация',
      key: 'organizationId',
      type: 'cascader',
      validation: [Validators.required()],
      payload: {
        options: orgs,
        fieldNames: {
          label: 'shortName',
          value: 'id',
          children: 'children',
        },
      },
    },
    {
      label: 'Роль',
      key: 'roleNames',
      type: 'select',
      payload: {
        options: allRoles,
        mode: 'multiple',
        fieldNames: {
          label: 'description',
          value: 'name',
        },
      },
    },
    {
      label: 'Должность',
      key: 'position',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'E-mail',
      key: 'email',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Номер телефона',
      key: 'phone',
      type: 'text',
    },
    {
      label: 'Отправлять ежедневную сводку',
      key: 'sendStatusMail',
      type: 'radioGroup',
      hidden: (form) => {
        const hide = form.getFieldValue('organizationId')?.length > 3;
        if (hide) form.setFieldValue('sendStatusMail', false);
        return hide;
      },
      payload: {
        direction: 'horizontal',
        options: [
          { value: true, label: 'Да' },
          { value: false, label: 'Нет' },
        ],
      },
    },
  ] as IFormItem[];
